export default {
  sales: [],
  salesById : []
}
